
export const sanitizeUrl = (unsafeUrl) => {
    const strippedUrl = decodeURI(unsafeUrl).replace(/(<([^>]+)>)/ig, '');
    return /^(http|https|mailto):.*/g.test(strippedUrl) ? encodeURI(strippedUrl) : '/';
};

export const getCurrentPageUrl = () => window.location.href;

export const getCurrentUrlPath = () => window.location.pathname;
